import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { Meta } from '../../../types/seo'


const SEO: React.FC<Props> = ({ description, lang = 'en', meta, title }) => {
  const { site } = useStaticQuery<QueryType>(SEOStaticQuery)

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : undefined}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `google-site-verification`,
          content: `j618Zn1505IS6VXySX_FetbshLN0d0jGXC_LPNPsX4c`,
        },
      ].concat(meta)}
    />
  )
}

//Types
type Lang = 'en';

interface Props {
  description?: string
  lang?: Lang
  meta: Meta
  title: string
}

type QueryType = {
  site: {
    siteMetadata: {
      title: string
      description: string
      author: string
    }
  }
}

const SEOStaticQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        description
        author
      }
    }
  }
`

export default SEO
